module.exports = __webpack_public_path__ + "media/images/new-ui-images/del-icon-modal-2b3f8d86f5f1068e8e6e949f5efbcea9.svg";